export default __webpack_public_path__ + "static/desktop_menu_KV04-b67c0ea72aad969384c4053218e78584.mp4";